"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordIdFieldLogic = void 0;
var record_id_fieldtype_1 = require("./record-id.fieldtype");
Object.defineProperty(exports, "RecordIdFieldLogic", { enumerable: true, get: function () { return record_id_fieldtype_1.RecordIdFieldLogic; } });
